<template>
  <Purchase />
</template>

<script>
import Purchase from "./movement/purchase.vue";

export default {
  name: "MenuPurchase",

  components: {
    Purchase,
  },
};
</script>
>